$(document).ready(() => {
    $('.product-slider .slick-slider').slick({
        dots: false,
        swipe: false,
        arrows: true,
        slidesToShow: 4,
        slidesToScroll: 4,
    })
})